<!-- listBoxInput.vue -->

<template>
  <div>
    <div class="form-floating">
        <input 
            v-model="searchText"
            :class="['form-control', formData.fields[fieldName].class]"
            @input="(!searchIn.alwaysList) ? searchList() : null"
            @blur="leaveFromInput"
            @focus="inToInput"
            @keydown.enter.prevent="searchTexto"
            :id="formData.fields[fieldName].id"
            :required="formData.fields[fieldName].required"
            autocomplete="off"
            :placeholder="['Escribe una ', formData.fields[fieldName].label]"
        />
        <label :for="formData.fields[fieldName].id">{{ formData.fields[fieldName].label }}</label>
        <div v-show="isLoading" class="loading-icon"><i class="fas fa-cog fa-spin"></i></div>

    </div>
    <div v-if="showListToSelect" class="products-list row" @mouseenter="overList" @mouseleave="leaveList">
        <div v-for="product in matchingValues" :key="product.id" @click.stop="selectregList(product)" class="product-card col-4 col-md-6 col-sm-12">
          <div class="product-image">
            <img :src="product.image_url" :alt="product.name">
          </div>
          <div class="product-details">
            <h5>{{ product.name }}</h5>
            <p>SKU: {{ product.sku }} | ID: {{ product.id }}</p>
            <div v-if="product.is_on_sale" class="prices">
              <span class="regular-price tachado">{{ product.regular_price }}</span>
              <span class="sale-price">{{ product.sale_price }}</span> |
              <span class="discount">{{ calculateDiscountPercentage(product.regular_price, product.sale_price) }}% OFF</span>
            </div>
            <div v-else>
              <span>{{ product.regular_price }}</span>
            </div>
          </div>
        </div>
      </div>


  </div>
</template>

<script>
const { replaceKeys } = require('@/js/utils.js');

export default {
    props: {
        fieldData: { type: Object, required: true },
        formValues: { type: Object, },
        formData: { type: Object, required: true },
        fieldName: { type: String, required: true }
    },
  watch: {
    fieldData(newVal) {
        this.searchText = newVal;
    }
  },
  computed: {
        fieldValue() {
            return this.fieldData;
        },
        showListToSelect() {
            return this.showList;
        }
   },
  data() {
    return {
      searchText: this.fieldData || '',
      matchingValues: [],
      searchIn : this.formData.fields[this.fieldName].component,
      showList: false,
      swOverList: false,
      lastSearch : ""
    };
  },
  methods: {
    async searchList() {

       if (this.formData.fields[this.fieldName].alwaysList) return;
       if (this.searchText.length < 3  ) return ;

       this.searchText = this.checkCase(this.searchText);
       if (this.searchText == this.lastSearch ) return ;

       this.searchListFrom();
    },
    async searchTexto() {
        if (this.formData.fields[this.fieldName].alwaysList) return;
        if (this.searchText.length < 1  ) return ;
         this.searchText = this.checkCase(this.searchText);
       if (this.searchText == this.lastSearch ) return ;

       this.searchListFrom();
    },
    async overList() {
        console.log("overList")
        this.swOverList=true;
    },
    async leaveList() {
        console.log("leaveList")
        this.swOverList=false;
    },
    inToInput() {
        if (!this.searchTex) this.searchTex = "";
        if (this.searchIn.alwaysList && this.matchingValues.length==0) {
            this.searchListFrom();
            return
        }
        if (this.searchText.length < 3 ) return;

        if (this.searchText.length >= 3 && this.lastSearch != this.searchText )  this.searchListFrom();
        //if (this.searchText.length >= 3 && this.lastSearch == this.searchText && this.matchingValues.length > 0 ) this.showList=true;
    },
    async leaveFromInput() {
        console.log("leaveFromInput swOverList:",this.swOverList)
        if (! this.swOverList) {
            this.showList=false;
            if (this.searchText != this.fieldData) this.searchText= (this.fieldData) ? this.fieldData : "";
        }
    },
    async searchListFrom() {
        // Verifica si hay un criterio mínimo para iniciar la búsqueda
        if (this.searchText.length < 3) return;

        try {
            const data = await this.getFromApi(this.searchIn)
            console.log("getFromApi st:",data)
            this.matchingValues = data.map(product => ({
                id: product.id,
                name: product.name,
                sku: product.sku,
                image_url: product.image_url,
                regular_price: product.regular_price,
                sale_price: product.sale_price || product.regular_price, // Usa regular_price si sale_price no está disponible
                is_on_sale: product.is_on_sale ? 1 : 0,
            }));

            // Muestra la lista si hay resultados
            this.showList = this.matchingValues.length > 0;
        } catch (error) {
            console.error("Error fetching products:", error);
            this.showList = false; // Oculta la lista si hay un error
        }
    },

      async getFromApi(searchIn) {
        console.log("searchIn.params:",searchIn.params)
        const params = {...{"term":this.searchText}, ...{"params": (searchIn.params) ? replaceKeys(searchIn.params,this.formValues): ""}}
        console.log("searchIn=>params:",params)

        const st = await this.$ajax(searchIn.action || searchIn.collection,params,"terms" )
        console.log("getFromApi:"+searchIn.action, st)
        return st.data;
    },
      

    getKey(vars,data,key) {
       let strKey=key;
       // eslint-disable-next-line no-useless-escape
       for (let v in vars) strKey = strKey.replace(new RegExp("\{\{"+vars[v]+"\}\}","gm"),data[vars[v]])
        return strKey;
      },
    calculateDiscountPercentage(regularPrice, salePrice) {
        const diff = regularPrice - salePrice;
        return Math.round((diff / regularPrice) * 100);
    },

    selectregList(regList) {
        this.showList=false;
        console.log("selectregList")
        if (!this.searchIn.set) this.searchIn.set = {[this.fieldName]: this.searchIn.field}
        if (!this.searchIn.set[this.fieldName]) this.searchIn.set[this.fieldName] =  this.searchIn.field;
        const json = {...this.searchIn.set}
        console.log("json before set:",json)
        for (const f in json) json[f] =  (!json[f]) ? "" : regList[json[f]] || null ;
        console.log("json after set:",json)
        this.$emit('input-change', json);
        return;
      //this.matchingValues = [];
    },
    prepareShow(regList,showStr) {
        return replaceKeys(showStr, regList);
    },
    checkCase(inputValue) {
        const currentClass = this.formData.fields[this.fieldName].class;

        if (currentClass.includes('uppercase')) {
            inputValue = inputValue.toUpperCase();
        } else if (currentClass.includes('downcase')) {
            inputValue = inputValue.toLowerCase();
        }

        return inputValue;
    }
  }
};
</script>

<style scoped>
.uppercase { text-transform: uppercase; }
.lowercase { text-transform: lowercase; }
.capitalize {text-transform: capitalize; }


.product-info {
  padding: 10px;
}

.product-sku, .product-name {
  margin-bottom: 10px;
}

.sale-price {
  text-decoration: line-through;
}

.discount-percent {
  margin-left: 10px;
  color: red;
}

@media (max-width: 768px) {
  .product-card {
    width: calc(50% - 20px);
    max-width: 700px;
  }
}

@media (max-width: 480px) {
  .product-card {
    width: calc(100% - 20px);
    max-width: 450px;
  }
}
.products-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.product-card {
  flex: 1 1 200px; /* Ajusta este valor para controlar cómo se escalan las tarjetas */
  border: 1px solid #ccc;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,.1);
  cursor: pointer;
  max-width: 400px;

}
.product-image img {
  max-width: 100%;
  height: auto;
}
.product-details {
  padding: 10px;
}
.tachado {
  text-decoration: line-through;
}


</style>
